import Link from 'next/link'
import styles from '@/styles/components/navigation/Breadcrumbs.module.scss'
import { useQuery } from '@/utils/url'

interface Props {
  values: Breadcrumb[]
}

interface Breadcrumb {
  name: string,
  prefix?: string,
  href?: { pathname: string; query: { [x: string]: string | string[] | undefined; }; }
}

export const Breadcrumbs: React.FC<Props> = ({ values }) => {
  return (
    <>
      <section className={styles.breadcrumbs}>
        <div className="container">
          <div className="relative">
            <nav className={styles.breadcrumbs_nav}>
              <ul className="flex">
                <li><Link href={useQuery('/')}>Home</Link><span className={styles.breadcrumbs_separator}>/</span></li>
                { values.map((breadcrumb: Breadcrumb, i) => {
                  if (breadcrumb.href) {
                    return (
                      <li key={i}>
                        <Link key={i} href={breadcrumb.prefix || '' + breadcrumb.href.pathname}>{ breadcrumb.name }</Link>
                        <span className={styles.breadcrumbs_separator}>/</span>
                      </li>
                    )
                  }
                  return <li key={i} className={styles.breadcrumbs_current}>{ breadcrumb.name }</li>
                }) }
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </>
  )
}
